import { useQuery } from "@tanstack/react-query";
import Clients from "core/api-clients";
import { IGetAccountQuicksightRequestModel } from "@lib/types";

export const adhocQueryKey = "adhocDashboard";

/**
 * Hook for getting the adhoc dashboard for the given account number and optional context id
 *
 * @param {IGetAccountQuicksightRequestModel} request
 */
export function useAccountQuicksight(
  request: IGetAccountQuicksightRequestModel,
) {
  return useQuery<string>({
    queryKey: [adhocQueryKey, request.account_number, request.context_id],
    queryFn: async () =>
      await Clients.ManagementBackend.Quicksight.get(request).then(
        (res) => res.embed_url,
      ),
  });
}
